// extracted by mini-css-extract-plugin
module.exports = {"radioContent":"WidgetTightOfferRadio_radioContent__3HajS","big":"WidgetTightOfferRadio_big__2Kfk-"};